import React, { useState } from "react";
import FormFilling from "./RemoveFurniture/FormFilling";
import GeneratedResults from "./FurnishHome/GeneratedResults";
import { uploadRemoveFurnitureImage, removeFurniture } from "../api/businesses";

const RemoveFurniture: React.FC = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [generatedImages, setGeneratedImages] = useState<any[]>([]);

  const handleProcessPhoto = async (images: File[]) => {
    setIsProcessing(true);
    setGeneratedImages([]);

    try {
      const generatedImagesList = [];

      for (const image of images) {
        const fileBuffer = await new Promise<string>((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result as string);
          reader.readAsDataURL(image);
        });

        const fileExtension = image.name.split(".").pop() || "jpg";
        const uploadResponse = await uploadRemoveFurnitureImage({
          fileBuffer: fileBuffer.split(",")[1],
          fileExtension,
        });

        const { documentId, beforeUrl } = uploadResponse.data;

        const generateResponse = await removeFurniture({
          image_url: beforeUrl,
          documentId,
        });

        const { result_image_url } = generateResponse.data;

        generatedImagesList.push({
          beforeUrl,
          afterUrl: result_image_url,
        });
      }

      setGeneratedImages(generatedImagesList);
      setShowResult(true);
    } catch (error) {
      console.error("Error processing images:", error);
      alert("Something went wrong while processing the images.");
    } finally {
      setIsProcessing(false);
    }
  };

  const handleGenerateNew = () => {
    setShowResult(false);
    setGeneratedImages([]);
  };

  return (
    <div className="p-6 flex flex-col items-center h-screen justify-center">
      {showResult ? (
        <GeneratedResults
          generatedImages={generatedImages}
          onGenerateNew={handleGenerateNew}
          isDeclutter={true}
        />
      ) : (
        <FormFilling
          onProcessPhoto={handleProcessPhoto}
          isProcessing={isProcessing}
        />
      )}
    </div>
  );
};

export default RemoveFurniture;
